// Copyright (C) 2017-2023 Smart code 203358507

const HorizontalNavBar = require('./HorizontalNavBar');
const VerticalNavBar = require('./VerticalNavBar');

module.exports = {
    HorizontalNavBar,
    VerticalNavBar
};
